import { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contextos/AuthContext';
import { Button, Icon, Input } from '../../../ui';
import AuthLayout from '../AuthLayout';
import styles from './CriarConta.module.css';

type Erros = {
  nome?: string;
  email?: string;
  senha?: string;
  confirmacao?: string;
};

/** Página dedicada de cadastro (rota /criar-conta). */
export default function CriarConta() {
  const { usuario, cadastrar, processando } = useAuth();
  const navigate = useNavigate();

  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [erros, setErros] = useState<Erros>({});
  const [erroGeral, setErroGeral] = useState('');

  // Quem já está logado não precisa criar conta.
  useEffect(() => {
    if (usuario) navigate('/dashboard');
  }, [usuario, navigate]);

  const validar = (): boolean => {
    const novos: Erros = {};
    if (!email.trim()) novos.email = 'Informe seu e-mail.';
    if (senha.length < 8) novos.senha = 'A senha precisa ter pelo menos 8 caracteres.';
    if (!novos.senha && confirmacao !== senha) novos.confirmacao = 'As senhas não coincidem.';
    setErros(novos);
    return Object.keys(novos).length === 0;
  };

  const submeter = async () => {
    if (processando) return;
    setErroGeral('');
    if (!validar()) return;

    const resultado = await cadastrar(email.trim(), senha, nome.trim() || undefined);
    if (resultado.ok) return; // o AuthContext já navega para /dashboard
    setErroGeral(resultado.mensagem || 'Não foi possível criar a conta. Tente novamente.');
  };

  return (
    <AuthLayout titulo="Crie sua conta" subtitulo="Em poucos minutos, seu dinheiro organizado e a planilha aposentada.">
      <div className={styles.form}>
        {erroGeral && (
          <div className={styles.alerta} role="alert">
            <Icon nome="error" tamanho={18} cor="var(--error)" />
            <span>{erroGeral}</span>
          </div>
        )}

        <Input
          label="Nome"
          icone="person"
          valor={nome}
          onChange={setNome}
          placeholder="Como podemos te chamar?"
          erro={erros.nome}
          autoFocus
          onEnter={submeter}
        />
        <Input
          label="E-mail"
          tipo="email"
          icone="mail"
          valor={email}
          onChange={setEmail}
          placeholder="voce@exemplo.com"
          erro={erros.email}
          obrigatorio
          onEnter={submeter}
        />
        <Input
          label="Senha"
          tipo="password"
          icone="lock"
          valor={senha}
          onChange={setSenha}
          placeholder="Crie uma senha"
          erro={erros.senha}
          dica="Pelo menos 8 caracteres."
          obrigatorio
          onEnter={submeter}
        />
        <Input
          label="Confirme a senha"
          tipo="password"
          icone="lock_reset"
          valor={confirmacao}
          onChange={setConfirmacao}
          placeholder="Repita a senha"
          erro={erros.confirmacao}
          obrigatorio
          onEnter={submeter}
        />

        <Button tamanho="lg" icone="rocket_launch" carregando={processando} onClick={submeter}>
          Criar conta
        </Button>

        <p className={styles.termos}>
          Ao criar a conta, você concorda com os{' '}
          <Link to="/termos-e-politicas" className={styles.link}>
            Termos de Serviço
          </Link>{' '}
          e a{' '}
          <Link to="/termos-e-politicas" className={styles.link}>
            Política de Privacidade
          </Link>
          .
        </p>

        <p className={styles.trocaFluxo}>
          Já tem uma conta?{' '}
          <Link to="/entrar" className={styles.link}>
            Entrar
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
